/**
 * Met à jour le cookie de campagne avec l'ID de la campagne spécifiée.
 * Si le cookie existe déjà, il incrémente la valeur associée à l'ID de la campagne.
 * Si le cookie n'existe pas, il crée un nouveau cookie avec la valeur initiale de 1 pour l'ID de la campagne.
 *
 * @param {string} idCampagne - L'ID de la campagne à mettre à jour dans le cookie.
 * @param {Date} [dateExpiration=new Date(new Date().setMonth(new Date().getMonth() + 1))] - La date d'expiration du cookie. Le format de la date doit être un objet Date valide.
 */
export function updateCookieCampaign(idCampagne, dateExpiration = new Date(new Date().setMonth(new Date().getMonth() + 1))) {
   const cookieName = 'o-HPevent';
   let cookieValue = {
      [idCampagne]: 1
   };
   let eventCookie = document.cookie.split('; ').find((cookie) => cookie.includes(cookieName));
   if (eventCookie) {
      try {
         let eventCookieValue = JSON.parse(eventCookie.split('=')[1]);
         const currentDisplayValue = parseInt(eventCookieValue[idCampagne], 10) || 0;
         cookieValue[idCampagne] = currentDisplayValue + 1;
      } catch (e) {}
   }
   document.cookie = `${cookieName}=${JSON.stringify(cookieValue)}; expires=${dateExpiration.toUTCString()}; path=/`;
}
